import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BaseAddTitle, { CatalogueResults } from '@bibliocommons/add-title';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import Pagination from '@bibliocommons/pagination';
import { FormattedMessage } from 'react-intl';
import { PrimaryButton } from '@bibliocommons/base-buttons';
import debounce from 'lodash/debounce';

import './AddTitle.scss';


export class AddTitle extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      isUpdatingResultItem: props.isUpdatingResultItem,
      query: '',
      doneButtonContainerWidth: 0,
      isInitialSearch: true
    };
    this.bindAll('handleCatalogueSearch', 'handleCatalogueSearchResults', 'handlePagination', 'handleResize', 'addTitleRef');
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.isInitialSearch) {
      const isQueryTheSame = nextProps.searchQuery.get('query') === this.state.query && nextProps.results === this.props.results;
      const hasResultsChanged = nextProps.results !== this.props.results;
      if (isQueryTheSame || hasResultsChanged) {
        this.setState({ isInitialSearch: false });
      }
    }
  }

  handleCatalogueSearch(query) {
    const { searchActions, searchQuery } = this.props;
    const curPage = query === searchQuery.get('query') ? searchQuery.get('pagination_page') : 1;
    searchActions.addTitleSearch({ ...searchQuery.toJS(), query, pagination_page: curPage });
    this.setState({ query });
  }

  componentDidMount() {
    window.addEventListener('resize', debounce(this.handleResize, 100));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    if (this._doneButtonContainer && this._addTitleWrapper) {
      this.setState({ doneButtonContainerWidth: `${this._addTitleWrapper.offsetWidth}px` });
    }
  }


  handlePagination(page) {
    const { searchActions, searchQuery } = this.props;
    searchActions.addTitleSearch({ ...searchQuery.toJS(), pagination_page: page });
  }

  renderPagination(focus, className = '') {
    const { isFetching, pagination } = this.props;
    return (
      <Pagination
        className={className}
        autoFocus={focus}
        isFetching={isFetching}
        textKey={'Search.paginationInfo'}
        page={pagination.get('page')}
        limit={pagination.get('limit')}
        count={pagination.get('count')}
        pages={pagination.get('pages')}
        queryField="pagination_page"
        updatePage={this.handlePagination} />);
  }

  handleCatalogueSearchResults() {
    const { zeroResults, results, availabilityDetailActions, addRowClassNames } = this.props;

    if (this.state.isInitialSearch || (zeroResults && !this.state.query)) {
      return null;
    } else if (zeroResults && this.state.query) {
      return (
        <div className="no-results-found">
          <FormattedMessage id="add_title_no_results_found" />
        </div>
      );
    }

    return (
      <div>
        <div className="pagination-holder">
          {this.renderPagination(true)}
          <CatalogueResults
            className="clearfix"
            searchResults={results}
            availabilityDetailActions={availabilityDetailActions}
            renderAddOn={(item) => this.props.renderAddOn(item)}
            addRowClassNames={addRowClassNames} />
          {this.renderPagination(false, 'pagination-right')}
        </div>
        <div className="clearfix done-button-container" style={{ width: this.state.doneButtonContainerWidth }} ref={(el) => { this._doneButtonContainer = el; }}>
          <PrimaryButton className="done-button" handleClick={this.props.handleClose}>
            <FormattedMessage id="done" />
          </PrimaryButton>
        </div>
      </div>);
  }

  addTitleRef(el) {
    this._addTitleWrapper = el;
  }

  render() {
    const { isFetching, isWrappedInForm } = this.props;
    const catalogueSearchOptions = {
      tabName: 'catalogue search',
      searchLabel: (<FormattedMessage id="search_by_keyword" />),
      handleSearch: this.handleCatalogueSearch,
      renderResults: this.handleCatalogueSearchResults,
      query: this.state.query
    };

    return (
      <div className="cp-shared-add-title" >
        <div className="add-title-wrapper" ref={this.addTitleRef}>
          <BaseAddTitle catalogueOptions={catalogueSearchOptions} onUpdateHandle={this.handleResize} searching={isFetching} isWrappedInForm={isWrappedInForm} />
        </div>
      </div>
    );
  }
}

AddTitle.propTypes = {
  searchActions: PropTypes.objectOf(PropTypes.func).isRequired,
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func).isRequired,
  searchQuery: ImmutablePropTypes.map.isRequired,
  pagination: ImmutablePropTypes.map.isRequired,
  zeroResults: PropTypes.bool.isRequired,
  results: ImmutablePropTypes.list.isRequired,
  handleClose: PropTypes.func.isRequired,
  addRowClassNames: PropTypes.func,
  renderAddOn: PropTypes.func,
  isFetching: PropTypes.bool,
  isWrappedInForm: PropTypes.bool,
  isUpdatingResultItem: PropTypes.bool
};

AddTitle.defaultProps = {
  renderAddOn: () => {},
  isWrappedInForm: false
};

export default AddTitle;



// WEBPACK FOOTER //
// ./app/components/shared/AddTitle/AddTitle.jsx